import { baseURL } from "../../util/Constant";
import { getMessage } from "../redux/messageSlice";
import { loadArchive, setSearchQuery, appendArchiveData } from "../redux/searchSlice";

export const searchArchiveFetch = (searchQuery, page = 1, limit = 40) => (dispatch) => {
    dispatch(loadArchive(false));
    fetch(`${baseURL}/search/get`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ searchQuery, page, limit }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.errorCode) {
          dispatch(getMessage(data.message));
          return;
        }
        dispatch(setSearchQuery(data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

export const searchArchiveLoadMore = (searchQuery, page, limit = 40) => (dispatch) => {
    dispatch(loadArchive(false));
    fetch(`${baseURL}/search/get`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ searchQuery, page, limit }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.errorCode) {
          dispatch(getMessage(data.message));
          return;
        }
        dispatch(appendArchiveData(data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

export const returnArchiveStatus = (id, searchQuery, page = 1, limit = 40) => (dispatch) => {
    dispatch(loadArchive(false));
    fetch(`${baseURL}/status/returnStatus`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.errorCode) {
          dispatch(getMessage(data.message));
          return;
        }
        dispatch(searchArchiveFetch(searchQuery, page, limit));
      })
      .catch((error) => {
        console.log(error);
      });
  };